import SearchInput from 'components/search-input/search-input'
import { AppsFilterAtom } from 'pages/browse-apps/browse-apps.service'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'
import { useSetRecoilState} from "recoil";

const Wishlist = () => {
  const {t} = useTranslation("browse-apps")
  const setFilters = useSetRecoilState(AppsFilterAtom)
  return (
    <div className="wishlist">
    <div className="header">
            <h1 className='title'>{t('wishList.myWishList')}</h1>
        <div className="page-action">
        <SearchInput onChange={(search) => setFilters(f => ({...f,search}))}/>
        </div>
    </div>
    <hr className="hr" />

    <Outlet />
    </div>
  )
}

export default Wishlist